import EventLineDetails from "./EventLineDetails";

export default EventLineDetails;
